import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionInfoComponent } from '../../components/version-info/version-info.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, VersionInfoComponent],
  template: `
    <footer class="app-footer">
      <div class="footer-container">
        <div class="copyright">
          © 2025 Sky Elemental - Appointment Bot
        </div>
        <div class="version-info">
          <app-version-info></app-version-info>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .app-footer {
      background: var(--ap-surface, #fff);
      border-top: 1px solid var(--ap-border, #E3E6EB);
      padding: 1rem;
    }

    .footer-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 1200px;
      margin: 0 auto;
    }

    .copyright {
      color: var(--ap-text-muted, #6B7280);
      font-size: 0.9rem;
    }

    .version-info {
      font-size: 0.9rem;
    }

    @media (max-width: 768px) {
      .app-footer {
        padding-bottom: calc(1rem + 64px);
      }

      .footer-container {
        flex-direction: column-reverse;
        align-items: center;
        gap: 0.5rem;
        text-align: center;
      }
    }
  `]
})
export class FooterComponent {}
